export default "__VITE_ASSET__BOTCG90F__"